import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { services } from "@/data/services";
import { cities } from "@/data/cities";
import { RevealBlock } from "@/components/Reveal";

export default function Coverage() {
  return (
    <>
      <SEO
        title="Coverage Atlas · Every Service × Every Nova Scotia Community"
        description={`Complete coverage atlas — 14 security services × ${cities.length} Nova Scotia communities. Dedicated landing pages for every combination, from mining security Halifax to event security Yarmouth.`}
        path="/coverage"
        keywords={[
          "security services all Nova Scotia cities",
          "Nova Scotia security company coverage",
          "province-wide security Nova Scotia",
          ...services.flatMap((s) => s.keywords || []).slice(0, 30),
        ]}
      />

      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 pt-16 md:pt-24 pb-16">
        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] mb-8">
          — Coverage Atlas · {services.length * cities.length} pages
        </p>
        <RevealBlock>
          <h1 className="font-serif text-[clamp(3rem,9vw,9rem)] leading-[0.88] tracking-tighter text-[#111111]">
            Every service.<br />
            <span className="italic text-[#184C59]">Every community.</span>
          </h1>
        </RevealBlock>
        <p className="mt-8 font-sans text-lg md:text-xl text-[#111111]/70 max-w-[64ch] leading-relaxed">
          {services.length} disciplines. {cities.length} Nova Scotia communities.{" "}
          {services.length * cities.length} dedicated landing pages, cross-linked and search-indexed. This is our full coverage atlas.
        </p>
      </section>

      {services.map((s) => (
        <section
          key={s.slug}
          className="border-t border-[#D9D6D0] py-16 md:py-20"
        >
          <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-12 gap-4 mb-10 items-baseline">
              <div className="col-span-12 md:col-span-3">
                <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#C17A43]">
                  Chapter {s.number}
                </p>
              </div>
              <div className="col-span-12 md:col-span-9">
                <Link
                  to={`/services/${s.slug}`}
                  className="font-serif text-3xl md:text-5xl leading-tight text-[#111111] hover:italic hover:text-[#C17A43] transition-colors"
                >
                  {s.name}
                </Link>
                <p className="mt-3 font-sans text-sm text-[#111111]/60 max-w-[64ch]">
                  {s.tagline}
                </p>
              </div>
            </div>
            <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-6 gap-y-1.5 border-t border-[#111111] pt-6">
              {cities.map((c) => (
                <li key={`${s.slug}-${c.slug}`}>
                  <Link
                    to={`/services/${s.slug}/${c.slug}`}
                    className="group flex items-baseline justify-between border-b border-[#D9D6D0] py-2 hover:border-[#111111]"
                  >
                    <span className="font-serif text-base md:text-lg text-[#111111]/80 group-hover:italic group-hover:text-[#C17A43] transition-colors">
                      {c.name}
                    </span>
                    <span className="opacity-30 group-hover:opacity-100 group-hover:translate-x-1 transition-transform text-sm">
                      →
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>
      ))}
    </>
  );
}
